import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import {
  acceptAllCookieConsent,
  acceptNecessaryCookieConsentOnly,
  getAnalyticsConsent,
  isCookieConsentAccepted,
} from '../utils/cookieConsent';

const COOKIE_POLICY_PATH = '/cerez-politikasi';

const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(() => !isCookieConsentAccepted());

  const handleAcceptAll = useCallback(() => {
    acceptAllCookieConsent();
    setVisible(false);
  }, []);

  const handleNecessaryOnly = useCallback(() => {
    acceptNecessaryCookieConsentOnly();
    setVisible(false);
  }, []);

  if (!visible) {
    return null;
  }

  const analyticsState = getAnalyticsConsent();

  return (
    <div
      className="sb-cookie-consent"
      role="dialog"
      aria-labelledby="sb-cookie-consent-title"
      aria-describedby="sb-cookie-consent-desc"
      aria-live="polite"
    >
      <div className="sb-cookie-consent__card shadow">
        <h2 id="sb-cookie-consent-title" className="sb-cookie-consent__title h6 mb-2">
          Çerez ve Analitik Tercihleri
        </h2>
        <p id="sb-cookie-consent-desc" className="sb-cookie-consent__text small mb-3">
          SadeceBilgisayar, oturum yönetimi ve güvenlik için gerekli çerezleri kullanır. İsteğe bağlı
          olarak, siteyi nasıl kullandığınızı anlamak ve deneyimi iyileştirmek için birinci taraf
          analitik verileri toplayabiliriz. Analitik veriler kişisel mesajlarınızı, arama metinlerinizi
          veya şifrelerinizi içermez. Tercihinizi istediğiniz zaman çerez politikası sayfasından
          değiştirebilirsiniz.
          {analyticsState === 'rejected' ? ' (Analitik şu an kapalı.)' : ''}
        </p>
        <div className="sb-cookie-consent__actions d-flex flex-wrap gap-2">
          <Button type="button" className="btn btn-primary btn-sm" onClick={handleAcceptAll}>
            Tümünü Kabul Et
          </Button>
          <Button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleNecessaryOnly}>
            Yalnızca Gerekli
          </Button>
          <Link to={COOKIE_POLICY_PATH} className="btn btn-outline-secondary btn-sm">
            Detayları Gör
          </Link>
        </div>
        <p className="small text-muted mt-2 mb-0">
          Yasal metinler için hukuk danışmanınıza danışmanız önerilir; bu metin bilgilendirme amaçlıdır.
        </p>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
